export const BIKES_PER_PAGE = 8;
